import script from "./team-default-view.vue?vue&type=script&setup=true&lang=js"
export * from "./team-default-view.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__